import { observable, action, computed } from "mobx";
import { IApp } from "@lib/common-interfaces";
import { githubPRStore } from "./data/github-pr-store";
import { GitHubRepo } from "./data/github-app-model";
import { GitHubPR } from "./data/github-pr-model";

export class FinishingUIStore {
  private repo: GitHubRepo | undefined | null;

  constructor(repo: GitHubRepo | null, installationId: string, accessTokenId: string, githubUserId: string) {
    this.repo = repo;
    if (!repo) {
      return;
    }
    githubPRStore.fetch({
      installationId: installationId,
      ownerName: repo.ownerName,
      repositoryName: repo.name,
      accessTokenId: accessTokenId,
      githubUserId: githubUserId,
    });
  }

  @computed get isPending() {
    return githubPRStore.isPending;
  }

  @computed get pullRequest(): GitHubPR | void {
    return !githubPRStore.isPending ? githubPRStore.data : (null as any);
  }

  @computed get targetBranch(): string | void {
    if (githubPRStore.isPending) {
      return;
    }
    return this.pullRequest ? this.pullRequest.base.ref : this.repo!.defaultBranch;
  }

  @computed get prHeadBranch() {
    return this.pullRequest && this.pullRequest.head && this.pullRequest.head.ref
      ? encodeURIComponent(this.pullRequest.head.ref)
      : null;
  }

  @computed get prHash() {
    return this.pullRequest && this.pullRequest.head && this.pullRequest.head.sha
      ? encodeURIComponent(this.pullRequest.head.sha)
      : null;
  }

  @observable public apps!: IApp[];
  @action public setApps = (apps: IApp[]) => {
    this.apps = apps;
  };
}
